import axios from './axiosService';

export default {
  getInstances() {
    return axios.get(`/api/meilisearch/instances`)
      .then(response => response.data);
  },
  getIndexes(instance) {
    return axios.get(`/api/meilisearch/instances/${instance}/indexes`)
      .then(response => response.data);
  },
  getIndex(indexName) {
    return axios.get(`/api/meilisearch/indexes/${indexName}`)
      .then(response => response.data);
  },
  getIndexSettings(indexName) {
    return axios.get(`/api/meilisearch/indexes/${indexName}/settings`)
      .then(response => response.data);
  },
  getIndexStats(indexName) {
    return axios.get(`/api/meilisearch/indexes/${indexName}/stats`)
      .then(response => response.data);
  },
  search(indexName, query) {
    const form = {
      q: query,
    }
    return axios.post(`/api/meilisearch/indexes/${indexName}/search`, form)
      .then(response => response.data);
  },
  getStats(instance) {
    return axios.get(`/api/meilisearch/instances/${instance}/stats`)
      .then(response => response.data);
  },
  getTasks(instance) {
    return axios.get(`/api/meilisearch/instances/${instance}/tasks`)
      .then(response => response.data);
  },
  deleteTasks(instance, form = {}) { // MLD-5132
    return axios.delete(`/api/meilisearch/instances/${instance}/tasks`, {data: form})
      .then(response => response.data);
  },
  getVersion(instance) {
    return axios.get(`/api/meilisearch/instances/${instance}/version`)
      .then(response => response.data);
  },
  getMetrics(instance) { // MLD-6027
    return axios.get(`/api/meilisearch/instances/${instance}/metrics`)
      .then(response => response.data);
  },
  getExperimentalFeatures(instance) { // MLD-6027
    return axios.get(`/api/meilisearch/instances/${instance}/experimental-features`)
      .then(response => response.data);
  },
}
